import {IDotRezBookingSessionCodesSettings} from "../../data-contracts/responses/booking/booking-session-codes-settings";
import {BookingSessionClassesOfService} from "./booking-session-classes-of-service";

export class BookingSessionCodesSettings {
    constructor(codesSettings: IDotRezBookingSessionCodesSettings) {
        this.classesOfService = new BookingSessionClassesOfService(codesSettings.classOfServices);
    }

    readonly classesOfService: BookingSessionClassesOfService;
}